import {history} from "../../redux/store";

// routing

export const goToStartPage   = (referer) => {
    history.push({
                     pathname: process.env.PUBLIC_URL + '/',
                     referer:  referer || ''
                 });
};
export const goToMainPage    = (referer) => {
    history.push({
                     pathname: process.env.PUBLIC_URL + '/main/',
                     referer:  referer || ''
                 });
};
export const goToShopPage    = (referer, filter, group) => {
    let s = '/main/shop/shop/';
    if (filter) {
        s += filter;
    }
    if (group) {
        s += '/' + group;
    }
    history.push({
                     pathname: process.env.PUBLIC_URL + s,
                     referer:  referer || ''
                 });
};
export const goToPaymentPage = (referer) => {
    history.push({
                     pathname: process.env.PUBLIC_URL + '/main/shop/payment/',
                     referer:  referer || ''
                 });
};
export const goToConfirm     = (referer) => {
    history.push({
                     pathname: process.env.PUBLIC_URL + '/main/shop/confirm/',
                     referer:  referer || ''
                 });
};
